<template>
  <div class="wrapper">
    <div class="container">
      <div class="h1">对此订单有疑问？</div>
      <div class="divider"></div>
      <div class="info">
        <span class="h1">{{ info.productName }}</span>
        <div class="price-container">
          <span class="price-label">实付款：</span>
          <span class="h1">￥{{ getYuan(info.actualAmount) }}</span>
        </div>
      </div>
      <div class="item">
        <span class="label">到期时间：</span>
        <span class="value">{{ formatDateTime(info.expireTime) }}</span>
      </div>
      <div class="item">
        <span class="label">交易账号：</span>
        <span class="value">{{
          (info.nickName || "") +
          (info.desensitizationPhoneNumber
            ? `(${info.desensitizationPhoneNumber})`
            : "")
        }}</span>
      </div>
      <div class="item">
        <span class="label">支付时间：</span>
        <span class="value">{{ formatDateTime(info.paymentTime) }}</span>
      </div>
      <button class="refund-button" @click="handleRefund">
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>
<script>
import kylogger from "@ky/sdk/dist/log/kylogger";
import { OrderStatusEnum, ORDER_DETAIL } from "@/utils/constant";
import { showToast, showConfirmDialog } from "vant";

export default {
  name: "RefundCard",
  props: {
    data: {
      type: Object,
      required: true,
    },
    post: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    kylogger.collect("SHOW", "REFUND_CARD", {});
    const info = JSON.parse(this.data.content);
    if (Array.isArray(info)) {
      this.info = info[0];
      return;
    }
    this.info = info;
  },
  computed: {
    buttonText() {
      const { orderStatus } = this.info;
      switch (orderStatus) {
        case OrderStatusEnum.REFUND_PROCESSING:
          return "退款审核中";
        case OrderStatusEnum.REFUND_SUCCESS:
          return "已退款";
        default:
          return "申请退款";
      }
    },
  },
  methods: {
    handleRefund() {
      const { orderStatus } = this.info;
      if (
        orderStatus === OrderStatusEnum.REFUND_PROCESSING ||
        orderStatus === OrderStatusEnum.REFUND_SUCCESS
      ) {
        this.openDetail();
        return;
      }
      kylogger.collect("CLICK", "REFUND_CARD", {});
      const beforeClose = (action) =>
        new Promise((resolve) => {
          kylogger.collect("CLICK", "REFUND_SECOND_CONFIRM", {
            clk_btn: action,
          });
          if (action === "confirm") {
            this.requestRefund();
          }
          resolve(true);
        });
      kylogger.collect("SHOW", "REFUND_SECOND_CONFIRM", {});
      showConfirmDialog({
        title: "是否确认退款",
        message: "退款申请将于24小时内审核完成，届时您将失去所有会员尊享权益",
        beforeClose,
        confirmButtonColor: "rgba(255, 255, 255, 0.9)",
        cancelButtonColor: "rgba(255, 255, 255, 0.5)",
      });
    },
    openDetail() {
      window.open(`${ORDER_DETAIL}&orderNo=${this.info.orderNo}`);
    },
    showKyToast(msg, icon) {
      const html1 = `<div style="color: #fff;padding: 10px 24px;background: rgba(34, 34, 34, 0.95); border-style: solid;border-width: 0.5px;border-color: rgba(255, 255, 255, 0.08);border-radius: 24px;flex-direction: row; display:flex; align-items: center;">`;
      const html2 = `<img
                      src="${icon}"
                      style="width: 20px; height: 20px; margin-right: 8px; vertical-align: middle;"
                    />`;
      const html3 = ` <span style="color: #fff; font-size: 14px; vertical-align: middle;">${msg}</span>
                </div>`;
      showToast({
        message: html1 + (icon ? html2 : "") + html3,
        type: "html",
      });
    },
    requestRefund() {
      this.post("/rest/n/fb/app/dialog/replyRefund", {
        orderNo: this.info.orderNo,
        productId: this.info.productId,
      })
        .then((res) => {
          if (res.result === 1) {
            this.showKyToast(
              "提交成功",
              "https://p4-ky.wsukwai.com/udata/pkg/kuaiying-frontend-cdn/udata/pkg/kuaiying-frontend-cdn/vip-student/toast_3x.b2505d4461da8f51.png",
            );
          } else {
            this.showKyToast(res.errorMsg || "提交失败,请重试");
          }
        })
        .catch((e) => {
          this.showKyToast(e.errorMsg || "提交失败,请重试");
        });
    },
    getYuan(fen = 0, fixed = 2) {
      return Number((Number(fen) / 100).toFixed(fixed));
    },
    formatDate(timestamp, showType = "-") {
      const date = timestamp ? new Date(timestamp) : new Date(); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const Y = date.getFullYear();
      const M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      const D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return `${Y}${showType}${M}${showType}${D}`;
    },
    formatDateTime(timestamp) {
      const date = timestamp ? new Date(timestamp) : new Date(); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const H = date.getHours();
      const M = date.getMinutes();
      const S = date.getSeconds();
      const time = `${H < 10 ? "0" + H : H}:${M < 10 ? "0" + M : M}:${
        S < 10 ? "0" + S : S
      }`;
      return `${this.formatDate(timestamp)} ${time}`;
    },
  },
};
</script>
<style>
.van-dialog {
  top: 40% !important;
}
.van-toast--html {
  padding: 0 !important;
  background: transparent !important;
}
.van-dialog__message--has-title {
  color: rgba(255, 255, 255, 0.5) !important;
}
</style>
<style lang="less" scoped>
.wrapper {
  display: flex;
  flex-direction: row;
}
.container {
  background-color: #1f1f1f;
  color: #fff;
  margin-top: 0.32rem;
  border-radius: 0.4rem;
  overflow: hidden;
  word-break: break-all;
  box-sizing: border-box;
  min-width: 80%;
  padding: 0.4rem 0.32rem;
  border-top-left-radius: 0.1rem;
}
.h1 {
  font-size: 16px;
  font-weight: 500;
}
.divider {
  margin: 0.32rem 0;
  border-bottom: 1px solid #333;
}
.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.price-container {
  display: flex;
  align-items: center;
  margin-left: 4px;
}
.price-label {
  color: #aaa;
  margin-right: 4px;
}
.item {
  display: flex;
  margin-bottom: 12px;
}
.label {
  color: #aaa;
}
.value {
  color: #aaa;
  flex: 1;
}
.refund-button {
  width: 100%;
  height: 45px;
  background-color: #333;
  color: #fff;
  border-radius: 8px;
  font-size: 16px;
  margin-top: 10px;
  border: none;
  cursor: pointer;
}
</style>
